import standaloneToast from './standaloneToast';

import i18n from '@/i18n';

const isValidOtp = ({
  value,
  number,
}: {
  value: string;
  number: number;
}): boolean => {
  if (value.length < number) {
    standaloneToast({
      status: 'error',
      title: i18n.t('utils.otpValidation.theVerificationCodesIs8Digits'),
    });
    return false;
  }
  return true;
};
export default isValidOtp;
